import React from 'react'

import TitleLogo from '../../Components/TitleLogo'
import Link from '../../Components/HeaderLink'
import Text from '../../Components/Text'

import './index.css'

const ContainerTitleLogoTextLinks = (({title,text,links,cols_links})=>(
	<div>
		{title ? <TitleLogo title={title} /> : ''}
		{text ? <Text text={text} /> : ''}
		{
			links && links.length>0 ? (
				<div className="links">
				{
					links.map((link,id)=>(
						<Link className="btn btn--small btn--1" target={link.target} text={link.caption} url={link.url}  key={id} />
					))
				}
				</div>
			):''
		}
		{
			cols_links && cols_links.length>0 ? (
				<div className="row row--links">
				{
					cols_links.map((link,id)=>(
						<div className="col">
							<h4>{link.text}</h4>
							<Link className="btn btn--5" target={link.link.target} text={link.link.caption} url={link.link.url} icon="download" key={id} />
						</div>
					))
				}
				</div>
			):''
		}
	</div>
))

export default ContainerTitleLogoTextLinks


// WEBPACK FOOTER //
// ./src/Containers/ContainerTitleLogoTextLinks/index.js